import React from 'react'
import { Team } from '../../types/teams'
import { TeamListItem } from './TeamListItem'

interface TeamListProps {
  teams: Team[]
  loading: boolean
  onInviteMembers: (teamId: string) => void
  onTeamAction: (teamId: string, action: string) => void
}

export const TeamList: React.FC<TeamListProps> = ({
  teams,
  loading,
  onInviteMembers,
  onTeamAction
}) => {
  if (loading) {
    return (
      <div className="space-y-4">
        {[...Array(3)].map((_, i) => (
          <div key={i} className="bg-white dark:bg-dark-surface border border-gray-200 dark:border-dark-border rounded-xl p-6">
            <div className="animate-pulse">
              <div className="flex items-center gap-4">
                <div className="w-20 h-20 bg-gray-200 dark:bg-gray-700 rounded-full"></div>
                <div className="flex-1">
                  <div className="h-5 bg-gray-200 dark:bg-gray-700 rounded w-3/4 mb-2"></div>
                  <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-1/2 mb-3"></div>
                  <div className="flex gap-4">
                    <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-20"></div>
                    <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-20"></div>
                    <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-24"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    )
  }

  if (!teams || !Array.isArray(teams) || teams.length === 0) {
    return (
      <div className="text-center py-16">
        <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4" style={{ background: 'linear-gradient(135deg, #FCB902 0%, #FF00CF 100%)' }}>
          <div className="w-8 h-8 bg-white dark:bg-dark-surface rounded-full"></div>
        </div>
        <h3 className="text-lg font-semibold text-gray-900 dark:text-dark-text mb-2">
          No teams yet
        </h3>
        <p className="text-gray-500 dark:text-dark-text-muted">
          Create your first team to start collaborating with others.
        </p>
      </div>
    )
  }

  return (
    <div className="space-y-4">
      {teams.map((team) => (
        <TeamListItem
          key={team.id}
          team={team}
          onInviteMembers={onInviteMembers}
          onTeamAction={onTeamAction}
        />
      ))}
    </div>
  )
} 